// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__2OQ8S","imageUploader":"EGiftCard_imageUploader__3q1xU"};